import React from "react";

import { Container, Input } from "./styles";

function Range({ min, max, value, onChange, onMouseUp }) {
  return (
    <Container>
      <Input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={event => onChange(event)}
        onMouseUp={() => onMouseUp()}
        onPointerUp={() => onMouseUp()}
      />
      <div className="notches">
        {[...Array(Number(max))].map((_, index) => (
          <div
            className={`notch ${
              index + 1 === Number(value) ? "transparent" : ""
            }`}
            key={index}
          ></div>
        ))}
      </div>
    </Container>
  );
}

export default Range;
